export const normalize = (phone: string) => {
  const plainNumbers = phone?.replace(/\D/g, '');
  return `+${!plainNumbers?.startsWith('1') ? '1' : ''}${plainNumbers}`;
};
